<template>
  <!-- <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="container-fluid container-p-x pb-3">
      <a href="#" class="footer-link pt-3">Link 1</a>
      <a href="#" class="footer-link pt-3 ml-4">Link 2</a>
    </div>
  </nav> -->
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
      <div class="container-fluid d-flex flex-wrap justify-content-between text-center container-p-x pb-3">
        <div class="pt-3">
          <span class="footer-text font-weight-bolder">MeritEHS</span> © {{ currentYear }} Powered By <a href="http://www.merittechnologies.com" target="_blank">Merit Technologies, LLC.</a>
          <span v-if="$root.env !== 'production' && this.$store.state.user" class="badge badge-warning">Logged into Account ID: {{ this.$store.state.user.SmartBizClientId }}, User ID: {{ this.$store.state.user.user_id }}</span>
        </div>
        <!-- <div>
          <a href="javascript:void(0)" class="footer-link pt-3">About Us</a>
          <a href="javascript:void(0)" class="footer-link pt-3 ml-4">Help</a>
          <a href="javascript:void(0)" class="footer-link pt-3 ml-4">Contact</a>
          <a href="javascript:void(0)" class="footer-link pt-3 ml-4">Terms &amp; Conditions</a>
        </div> -->
      </div>
    </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',

  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  },

  computed: {
    currentYear(){
      return (new Date().getFullYear());
    }
  }
}
</script>
